export default "__VITE_ASSET__D0wfMki3__"